<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t('user') }} {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <button type="button" @click.stop="showSmallModal = true;" class="action-button">{{ $t('create_new') }}</button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th class="w25p" @click="toggleSort('user', 'user_account')">
              {{ $t('user') }} ID
              <span v-if="sortStates.user.find(col => col.id === 'user_account').order">
                <img v-if="sortStates.user.find(col => col.id === 'user_account').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w25p" @click="toggleSort('user', 'user_name')">
              {{ $t('user') }} {{ $t('name') }}
              <span v-if="sortStates.user.find(col => col.id === 'user_name').order">
                <img v-if="sortStates.user.find(col => col.id === 'user_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w25p" @click="toggleSort('user', 'email')">
              {{ $t('email') }}
              <span v-if="sortStates.user.find(col => col.id === 'email').order">
                <img v-if="sortStates.user.find(col => col.id === 'email').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('user', 'role')">
              {{ $t('authority') }}
              <span v-if="sortStates.user.find(col => col.id === 'role').order">
                <img v-if="sortStates.user.find(col => col.id === 'role').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in paginatedData" :key="user.user_id" :style="user.is_deleted ? { background: '#EBEBEB' } : {}">
            <td :title="user.user_account" class="w25p" @click.stop="editUser(user)">
              {{ user.user_account }}
            </td>
            <td v-show="!getIsMobile()" :title="user.user_name" class="w25p" @click.stop="editUser(user)">
              {{ user.user_name }}
            </td>
            <td v-show="!getIsMobile()" :title="user.email" class="w25p" @click.stop="editUser(user)">
              {{ user.email }}
            </td>
            <td v-show="!getIsMobile()" :title="user.role" class="w15p" @click.stop="editUser(user)">
              {{ user.role }}
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-if="!user.is_deleted">
              <img @click.stop="editUser(user)" src="@/assets/images/edit.svg" :title="$t('modify')"/>
              <img @click.stop="deleteUser(user.user_account)" src="@/assets/images/delete.svg" :title="$t('delete')"/>
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-else>
              <img @click.stop="restoreUser(user.user_account)" src="@/assets/images/restore.svg" :title="$t('restore')"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <!-- #region 사용자 개별 관리 모달 -->
    <div v-if="showSmallModal" class="modal-body-content-modal-background">
      <div class="modal-body-content-modal">
        <div class="modal-body-edit-box">
          <div class="modal-body-edit-box-title">
            <h2>{{ selectedAccount ? $t('modify_user') : $t('add_user') }}</h2>
            <img src="@/assets/images/x_black.svg" @click="resetForm()"/>
          </div>
          <div class="modal-body-edit-box-content">
            <div class="modal-body-edit-box-content-main">
              <table>
                <tbody style="border-top: none;">
                  <tr>
                    <td style="display: flex; width: 100%; border: none; height: fit-content; justify-content: end; margin-top: -10px;">
                      <button class="reset-password" style="align-items: right; text-align: right; width: fit-content;" @click="resetPassword" :disabled="!selectedAccount">{{ $t('reset_password') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('user') }} ID</th>
                    <td><input v-model="userAccount" :placeholder="$t('enter_your_user_id')" required :disabled="selectedAccount" /></td>
                  </tr>
                  <tr>
                    <th>{{ $t('user') }} {{ $t('name') }}</th>
                    <td><input v-model="userName" :placeholder="$t('enter_your_user_name')" required /></td>
                  </tr>
                  <tr>
                    <th>{{ $t('email') }}</th>
                    <td><input v-model="email" type="email" :placeholder="$t('enter_your_email')" /></td>
                  </tr>
                  <tr>
                    <th>{{ $t('authority') }}</th>
                    <td>
                      <select v-model="role">
                        <option value="root">Root</option>
                        <option value="user">User</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="button-group">
                <button type="button" @click.stop="resetForm()" class="cancel-button">{{ $t('cancel') }}</button>
                <button v-if="selectedAccount && selectedAccount && !selectedAccount.is_deleted" type="button" @click.stop="deleteUser(selectedAccount.user_account)" class="delete-button">{{ $t('delete') }}</button>
                <button v-else-if="selectedAccount && selectedAccount && selectedAccount.is_deleted" type="button" @click.stop="restoreUser(selectedAccount.user_account)" class="retrieve-button">{{ $t('restore') }}</button>
                <button type="button" @click.stop="saveUser()" class="action-button">{{ $t('submit') }}</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>
  
<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { SERVER_REQUEST, GET_SERVER_REQUEST, user_list } from '../utils/ServerConnect';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedUserList, sortStates, toggleSort } from '@/utils/SortUtility';
import { getIsMobile, loginedUserData, SendErrorLog } from '@/utils/GlobalUtility';

const selectedAccount = ref(null);
const nowUserData = ref();
const userAccount = ref("");
const userName = ref("");
const email = ref("");
const role = ref("user"); // 기본값 user
const showSmallModal = ref(false);

// API를 통해 장치정보 받아오기
const fetchUserData = async () => {
  loadingStore.showLoading();

  user_list.value = await GET_SERVER_REQUEST('user');

  loadingStore.hideLoading();
};

const saveUser = async () => {
  if (!selectedAccount.value) {
    if (!userName.value || !userAccount.value) {
        showNotification('모든 필드를 입력해주세요.', 'warn', 'top-center');
        return;
    }

    const totalData = {
        user_account: userAccount.value,
        user_name: userName.value,
        email: email.value,
        role: role.value
    }
    const jsonData = JSON.stringify(totalData);
    const response = await SERVER_REQUEST("user", "POST", jsonData, false)
    if (response.message) {
      showNotification("사용자가 생성되었습니다.\nID : " + userAccount.value, 'alarm', 'top-center');
      // SendErrorLog('User', { 
      //   name: 'Save success',
      //   message: userAccount.value,
      //   stack: `Saved data : ${totalData}`,
      // });
    } else {
      SendErrorLog(`User-Save(${totalData.user_account})`, response);  
    }
  } else {
    const totalData = Object.assign(
        { user_account: userAccount.value },
        userName.value !== selectedAccount.value.user_name ? { user_name: userName.value } : {},
        email.value !== selectedAccount.value.email ? { email: email.value } : {},
        role.value !== selectedAccount.value.role ? { role: role.value } : {},
    );

    const jsonData = JSON.stringify(totalData);
    const result = await SERVER_REQUEST('user', 'PUT', jsonData, false)
    if (result.message) {
        let changes = [];
        if (selectedAccount.value.user_name !== userName.value) {
        changes.push(`user_name(${selectedAccount.value.user_name} > ${userName.value})`);
        }
        if (selectedAccount.value.email !== email.value) {
        changes.push(`email(${selectedAccount.value.email} > ${email.value})`);
        }
        if (selectedAccount.value.role !== role.value) {
        changes.push(`role(${selectedAccount.value.role} > ${role.value})`);
        }
        // const stack = changes.length > 0 ? `수정된 항목 : ${changes.join(', ')}\n수정자 : ${nowUserData.value.user_name}(${nowUserData.value.user_account})` : "변경된 내용 없음";

        // SendErrorLog('User', { name: 'Modify success',
        //                     message: `Modified id : ${userAccount.value}`,
        //                     stack: stack,})

        showNotification('사용자 정보 수정이 완료되었습니다.', 'alarm', 'top-center');
    } else SendErrorLog('User', result.error);
  }
  resetForm();
};

// ✅ 계정 선택 시 입력 필드 채우기
const editUser = (account) => {
  showSmallModal.value = true;
  if (selectedAccount.value === account) return resetForm();
  selectedAccount.value = account;
};

const resetPassword = async () => {
  const totalData = {
    user_account: selectedAccount.value.user_account
  };
  const jsonData = JSON.stringify(totalData);
  const result = await SERVER_REQUEST('user', 'POST', jsonData, false, { 'Content-Type': 'application/json' }, '/reset-password');
  if (result.message) {
    // const stack = `초기화된 계정 : ${selectedAccount.value.user_name}(${selectedAccount.value.user_account})\n작업자 : ${nowUserData.value.user_name}(${nowUserData.value.user_account})`;
    // SendErrorLog('C101', { name: 'Password reset success',
    //                        message: `Reseted id : ${selectedAccount.value.user_account}`,
    //                        stack: stack,})

    showNotification('사용자의 비밀번호가 초기화되었습니다.', 'alarm', 'top-center');
  } else SendErrorLog('User', result.error);
}

const deleteUser = async (id) => {
  const totalData = {
    user_account: id
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  await SERVER_REQUEST('user', 'DELETE', jsonData);
  loadingStore.hideLoading();
  resetForm();
}

const restoreUser = async (id) => {
  const totalData = {
    user_account: id,
    undelete: true
  }
  const jsonData = JSON.stringify(totalData);

  loadingStore.showLoading();
  await SERVER_REQUEST('user', 'DELETE', jsonData);
  loadingStore.hideLoading();
  resetForm();
}

const resetForm = async () => {
  showSmallModal.value = false;
  selectedAccount.value = null;
  userAccount.value = "";
  userName.value = "";
  email.value = "";
  role.value = "user";

  await fetchUserData();
}

const setNowUserData = () => {
  userAccount.value = selectedAccount.value?.user_account;
  userName.value = selectedAccount.value?.user_name;
  email.value = selectedAccount.value?.email;
  role.value = selectedAccount.value?.role;
  if (!role.value) role.value = "user";
}
watch(selectedAccount, () => setNowUserData());

// Initialize map on component mount
onMounted(async () => {
  nowUserData.value = await loginedUserData();
  fetchUserData();
  loadingStore.hideLoading();
});

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedUserList.value.filter(user =>
  String(user.user_account).toLowerCase().includes(query) // ID로 검색
    || String(user.user_name).toLowerCase().includes(query) // 이름으로 검색
    || String(user.email).toLowerCase().includes(query) // 이메일로 검색
    || String(user.role).toLowerCase().includes(query) // 권한으로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
</script>